import { render, staticRenderFns } from "./HistoricoPagamento.vue?vue&type=template&id=01ba5cf1"
import script from "./HistoricoPagamento.vue?vue&type=script&lang=js"
export * from "./HistoricoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports